import React from "react";
import { Text4, Text5 } from "../../../styles";
import { printRupee } from "../../../app_methods";
import moment from "moment";
import { Badge } from "antd";
import {
    API_REQUESTS_STATUS_TYPES,
    API_REQUESTS_TYPES,
} from "../../../constants";

export const getAPIRequestsTableColumns = (methods) => [
{
    title: "URN",
    key: "urn",
    render: (record) => <Text4>{record.merchant_request_number}</Text4>
},
{
    title: "Requested At",
    key: "created_at",
    render: (record) => <Text4>{moment(record.created_at).format("lll")}</Text4>
},
{
    title: "Details",
    key: "details",
    render: (record) =>
        <div>
            <Text4 className="d-block">{record.beneficiary_account_name}</Text4>
            {
                record.api_type == "VPA_VERIFICATION_API"?
                    <Text5 style={{ width:'300px', overflowWrap: 'break-word' }} className="w-100 d-flex justify-content-between mt-4" secondary>{record.request_payload?record?.request_payload?.merchant_request?.upi_handle:'-'}</Text5>
                    :null
                
            }
            {
                ["PENNY_DROP_API", "PENNYLESS_API"].includes(record.api_type) ?<>
                    <Text5 className="d-block" secondary>{record.request_payload?record?.request_payload?.merchant_request?.account_number:'-'}</Text5>
                    <Text5 className="d-block" secondary>{record.request_payload?record?.request_payload?.merchant_request?.account_ifsc?.toUpperCase() :'-'}</Text5>
                    </>:null
            }
            {
                record.api_type == "BANK_STATUS" ?<>
                    <Text5 className="d-block" secondary>{record.request_payload?record?.request_payload?.merchant_request?.ifsc?.toUpperCase() :'-'}</Text5>
                    <Text5 className="d-block" secondary>{record.response_payload?record?.response_payload?.raw_response?.bank_name:'-'}</Text5>
                    </>:null
            }
            {
                record.api_type == "PENNY_DROP_FUZZY_API" ?<>
                    <Text5 className="d-block" secondary>{record.request_payload?record?.request_payload?.merchant_request?.account_number:'-'}</Text5>
                    <Text5 className="d-block" secondary>{record.response_payload?record?.request_payload?.merchant_request?.account_ifsc?.toUpperCase() :'-'}</Text5>
                    </>:null
            }
            {
                record.api_type == "IFSC_VERIFICATION" ?<>
                    <Text5 className="d-block" secondary>{record.response_payload?record?.request_payload?.merchant_request?.account_ifsc?.toUpperCase() :'-'}</Text5>
                    </>:null
            }
            {
                record.api_type == "GSTIN_VERIFICATION" ?<>
                    <Text5 className="d-block" secondary>{record.response_payload ? record.response_payload?.processed_response?.gstin?.toUpperCase() :'-'}</Text5>
                    </>:null
            }
             {
                record.api_type == "PAN_VERIFICATION" ?<>
                    <Text5 className="d-block" secondary>{record.response_payload ? record.response_payload?.processed_response?.pan_number?.toUpperCase() :'-'}</Text5>
                    </>:null
            }
        </div>
},
{
    title: "Name",
    key: "name",
    render: (record) => <Text4>{record.name?.length !== 0 && record?.name !=="Na" ? record.name : "---"}</Text4>
},
{
    title: "Verification Type",
    key: "api_type",
    render: (record) => <Text4>{API_REQUESTS_TYPES[record.api_type]?.label}</Text4>
}, {
        title: "Charge",
        key: "charge",
        render: (record) => (
            <Text4>
                {record.status == "success" && record.is_valid
                    ? printRupee(record.service_charge)
                    : printRupee(0)}
            </Text4>
        ),
    },
    {
        title: "Response Status",
        key: "response_status",
        render: (record) => <Text4>{record?.response_status ? record?.response_status : "---" }</Text4>,
    },
];

// export const APIRequestsTableFilterNodes = (params = {}, current_user) => {
export const APIRequestsTableFilterNodes = (params = {}) => {
    // let nodes = [
    return [
        {
            label: "Created At",
            field: "created_at",
            placeholder: "Select API Request Date",
            inputType: "date_range",
            defaultValue: [moment().subtract(3, "days"), moment()],
            preventClear: true
        },
        {
            label: "Verification Type",
            field: "api_type",
            placeholder: "Enter Verification Type",
            inputType: "select",
            defaultValue: undefined,
            options: Object.keys(API_REQUESTS_TYPES).map((type, index) => {
                let object = {};
                object.key = index;
                object.value = type;
                object.label = <Text4>{API_REQUESTS_TYPES[type].label}</Text4>;
                return object;
            }),
        },
        {
            label: "Status",
            field: "status",
            placeholder: "Select Status",
            inputType: "select",
            // placeholder: "Select API Status",
            defaultValue: undefined,
            options: Object.keys(API_REQUESTS_STATUS_TYPES).map(
                (type, index) => {
                    let object = {};
                    object.key = index;
                    object.value = type;
                    object.label = (
                        <Badge
                            color={API_REQUESTS_STATUS_TYPES[type].color}
                            text={
                                <Text4>
                                    {API_REQUESTS_STATUS_TYPES[type].label}
                                </Text4>
                            }
                        />
                    );
                    return object;
                }
            ),
        },
    ];
    // if (current_user.is_reseller && current_user.esda){
    //     nodes.unshift({
    //         label: "Merchant",
    //         field: "submerchant_id",
    //         placeholder: "Merchant ID",
    //         width: 250,
    //         inputType: "select",
    //         showSearch: true,
    //         defaultValue: undefined,
    //         options: current_user.submerchants ? current_user.submerchants.map((sub_merchant, index) => {
    //             let object = {};
    //             object.key = index;
    //             object.value = sub_merchant.id;
    //             object.label = sub_merchant.name+" ("+sub_merchant.email+")"
    //             return object;
    //         }): []

    //     })
    // }
    // return nodes 
};

export const VERIFICATION_PERMISSIONS = [
    "PENNY_DROP",
    "ADVANCED_PENNY_DROP",
    "VPA_VERIFICATIONS",
    "PENNYLESS"
]

export const BULK_VERIFICATION_PERMISSIONS = [
    "BULK_PENNY_DROP",
    "BULK_ADVANCED_PENNY_DROP"
]

export const VERIFICATION_SETTINGS = [
    "ebav",
    "ebavwfc",
    "euv",
    "eplv"
]

export const BULK_VERIFICATION_SETTINGS = [
    "ebav",
    "ebavwfc"
]
